import React from 'react'

function AngleBracketLeft() {
  return (

      <svg width="16px" height="16px" viewBox="0 0 1024 1024" data-aut-id="icon" class="" fill-rule="evenodd"><path class="rui-32D-k" d="M684.685 85.333l-407.352 396.501v60.331l407.352 396.501h61.982v-60.331l-376.339-366.336 376.339-366.336v-60.331z"></path></svg>
    
  )
}

export default AngleBracketLeft
